module.exports = __webpack_public_path__ + "img/CeltCapTechCallOfRatis.10d46a41.webp";